import feathersClient from "../../feathers-client";

const defaultRedeploymentRequestPagination = {
	total:100,
	$skip:0,
	$limit:2,
};
const defaultRedeploymentRequestPaginationFilter = {
	$skip:defaultRedeploymentRequestPagination.$skip,
	$limit: defaultRedeploymentRequestPagination.$limit
};

export default {
	state:{
		RedeploymentRequestPagination:defaultRedeploymentRequestPagination,
		redeploymentRequest:[],
		RedeploymentRequestPaginationFilter:defaultRedeploymentRequestPaginationFilter,
        RedeploymentRequestFilter:defaultRedeploymentRequestPaginationFilter,
	},
	getters:{
		setRedeploymentPage:(state) => {
			const {$limit, $skip} = state.RedeploymentRequestPagination;
			return $skip / $limit + 1;
		}

	},
	mutations:{
		SET_REDEPLOYMENT_REQUEST:(state,data) => {state.redeploymentRequest = data},
		SET_REDEPLOYMENT_REQUEST_PAGINATION:(state, data) => {state.RedeploymentRequestPagination = {...state.RedeploymentRequestPagination, ...data};},
		SET_REDEPLOYMENT_REQUEST_PAGINATION_FILTER:(state,data) => {state.RedeploymentRequestPaginationFilter  = {...state.RedeploymentRequestPaginationFilter, ...data};},
        SET_REDEPLOYMENT_REQUEST_LIST_FILTER:(state,data) => {state.RedeploymentRequestFilter = {...state.RedeploymentRequestFilter, ...data}},
	},
	actions:{
		setRedeploymentRequestListPage:({commit,state},page) =>{
			const $skip = (page - 1) * state.RedeploymentRequestPagination.$limit;
			commit('SET_REDEPLOYMENT_REQUEST_PAGINATION', { $skip });
			commit('SET_REDEPLOYMENT_REQUEST_LIST_FILTER', { $skip });
		},

		getRedeploymentRequest: async({rootGetters,commit, state},filter) => {
			const results = await feathersClient.service('/api/v3/redeployment-requests').find({
				query:{
					$role: rootGetters.currentUserRole,
					...filter
				}
			});
			commit('SET_REDEPLOYMENT_REQUEST',results.data)
			commit('SET_REDEPLOYMENT_REQUEST_PAGINATION', {total :results.total})
			return results.data;
		},
		updateRequest: async ({ rootGetters, commit, state }, filter) => {
			if (!filter.id) {
				throw new Error('updateJob: missing job id');
			}

			const id = filter.id;

			// Remove id before putting filter params into query
			const { id: _, ...queryFilter } = filter;

			const result = await feathersClient
				.service('/api/v3/redeployment-requests')
				.patch(
					id,       // <-- REQUIRED (this is the URL :id)
					{},       // <-- REQUIRED data object (empty is OK)
					{
						query: {
							$role: rootGetters.currentUserRole,
							...queryFilter
						}
					}
				);

			commit('SET_REDEPLOYMENT_REQUEST', result);
			return result;
		},
		exportRedeploymentRequest: async ({rootGetters}, filter) => {
			const results = await feathersClient.service('/api/v3/redeployment-requests').find({
				query:{
					$role: rootGetters.currentUserRole, 
					trustId: rootGetters.currentTrustId,
					...filter
				}
			});
			return results;
		}

	

	}
}
